import React from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';

import Tooltip from 'editor/components/Tooltip';
import useSingleFileDropzoneProps from 'editor/components/Upload/useSingleFileDropzoneProps';

export default function BtnImgUpload({
    onDropSuccess = () => {},
    onDropError = () => {},
    firstView = false
}) {
    const { getRootProps, getInputProps } = useSingleFileDropzoneProps({
        enableBase64: true,
        onDropSuccess,
        onDropError
    });

    return (
        <Tooltip
            title={i18n.t('label.img.suggested_size', {
                width: 640,
                height: 430,
                unit: 'px'
            })}
            placement="bottom"
            arrow
        >
            <Button
                className="btn-upload-img"
                css={btnStyle}
                variant="contained"
                startIcon={<AddCircleIcon />}
                {...getRootProps()}
            >
                {i18n.t('btn.change_img')}
                {!firstView && <input {...getInputProps()} />}
            </Button>
        </Tooltip>
    );
}

const btnStyle = css`
    z-index: 3;
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translate(-50%, 0);
    opacity: 0;
    transition: all 0.2s linear;
    padding: 8px 24px;
    color: #333;
    background-color: #fff;
    border-radius: 8px;
    white-space: nowrap;
`;
